import React from 'react';
import styled from 'styled-components';
import {
  Badge,
} from 'react-bootstrap';

import BidOnAuctionForm from '../BidOnAuctionForm';
import WeiToEth from '../WeiToEth';
import TimeRemaining from '../TimeRemaining';
import TokenThumbnail from '../TokenThumbnail';

const ThisBadge = styled(Badge)`
  position: absolute;
  top: 6px;
  left: 25%;
  right: 25%;
  background-color: ${props => props.status === "winning" ? "#19AC84" : "red"};
  padding: 11px 0 10px;
  text-transform: uppercase;
  border-radius: 20px;
`;

const ThisTokenThumbnail = styled(TokenThumbnail)`
  padding: 20px 20px 0;
  border-radius: 0;
  box-shadow: 0px 2px 1px rgba(0,0,0,0.1);

  img {
    border-radius: 6px;
    box-shadow: 0px 3px 11px rgba(0, 0, 0, 0.3);
    filter: brightness(25%) grayscale(100%);
  }

  dl {
    position: absolute;
    top: 80px;
    left: 0;
    color: white;
    text-align: center;
    width: 100%;
  }

  dt {
  }

  dd {
    padding-bottom: 20px;
  }
`;

const BidCard = ({
  auction,
  metadata,
  bid,
  status,
}) => (
  <ThisTokenThumbnail ipfsPath={metadata.image}>
    <ThisBadge status={status}>{status}</ThisBadge>

    <dl>

      {status === "losing" &&
        <div>
          <dt>Highest Bid</dt>
          <dd><WeiToEth amount={auction.highestBidAmount} /></dd>
        </div>
      }

      <dt>Your Bid</dt>
      <dd><WeiToEth amount={bid} /></dd>

      <dt>Time Left</dt>
      <dd><TimeRemaining blocks={auction.endsAtBlock} /></dd>

    </dl>

    {status === "losing" &&
      <BidOnAuctionForm
        auctionIndex={auction.auctionIndex}
        highestBid={auction.highestBidAmount} />
    }
  </ThisTokenThumbnail>
);

export default BidCard;



// WEBPACK FOOTER //
// ./src/components/ui/BidCard.js